import React, { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { RelationshipSection } from '../../../../modernization-common/relationships';
import { relationshipLabelsForSourceAtom, selectedAnnotationRelationshipsAtom } from '../../atoms/relationship-atoms';
import { allAnnotationMapAtom } from '../../atoms/side-panel-atoms';
type ViewRelationshipsProps = {
  onCreateRelationship: () => void;
  onEditRelationship: (relationshipId: string) => void;
  onDeleteRelationship: (relationshipId: string) => void;
  isVideoTask: boolean;
  readOnly?: boolean;
};
export const ViewRelationships = ({
  onCreateRelationship,
  onEditRelationship,
  onDeleteRelationship,
  isVideoTask,
  readOnly
}: ViewRelationshipsProps) => {
  const relationships = useAtomValue(selectedAnnotationRelationshipsAtom);
  const allAnnotationsMap = useAtomValue(allAnnotationMapAtom);
  const hasAvailableLabels = useAtomValue(relationshipLabelsForSourceAtom)?.length > 0;
  const getTargetDisplayName = useCallback((annotationId: string): string => {
    const annotation = allAnnotationsMap[annotationId];
    if (!annotation) return annotationId;
    return `${annotation.annotation.annotationLabel.title}[${annotationId}]`;
  }, [allAnnotationsMap]);
  return <RelationshipSection relationships={relationships} getTargetDisplayName={getTargetDisplayName} onCreateRelationship={onCreateRelationship} onEditRelationship={onEditRelationship} onDeleteRelationship={onDeleteRelationship} isVideoTask={isVideoTask} readOnly={readOnly} disabledReason={!hasAvailableLabels ? 'No relationship types configured for this source' : undefined} />;
};